ch-paginator-navigate[disabled] {
  pointer-events: none;
}